module.exports = __webpack_public_path__ + "static/media/WIN_20210315_23_43_51_Pro__3_-removebg-preview.2eefe0f0.png";